// Plain-language names of the audited entities, keyed by the backend's CLR names.
export const ENTITY_LABELS: Record<string, string> = {
  Trip: "Orari",
  Schedule: "Ndalesa e orarit",
  Line: "Linja",
  Price: "Çmimi",
  Station: "Stacioni",
  City: "Qyteti",
  Country: "Shteti",
  Operator: "Operatori",
  Ticket: "Bileta",
  JourneyReservation: "Rezervimi",
  TicketUserInfo: "Pasagjeri",
  JourneyTicketMapping: "Bileta e rezervimit",
  CustomTripWorkingDay: "Ditë e veçantë e orarit",
  CustomTripReservabilityDate: "Datë rezervueshmërie",
  CustomReservationThreshold: "Kufiri i rezervimeve",
  // The class is TripsNotices; a label keyed "TripNotice" never matched a row.
  TripsNotices: "Njoftimi i orarit",
  PromotionCode: "Kodi promocional",
  BusTripMapping: "Autobusi i orarit",
  Bus: "Autobusi",
  BusSeat: "Ulësja",
  Blog: "Blogu",
  UserFeedback: "Feedback-u i klientit",
  VoucherCode: "Kodi i voucher-it",
  TravelBundle: "Paketa",
  TravelBundleInclude: "Përfshirja e paketës",
  TravelBundleDetail: "Periudha e paketës",
  TravelBundleIncludeMapping: "Përfshirja në paketë",
  TravelBundleLocationMapping: "Qyteti i paketës",
  TravelBundlePictureMapping: "Fotoja e paketës",
  BlogPictureMapping: "Fotoja e blogut",
  EntityPictureMapping: "Fotoja e lidhur",
  Picture: "Fotoja",
  UserRole: "Roli i përdoruesit",
  UserRoleMapping: "Roli i dhënë",
  InvitedUserRoleMapping: "Roli i ftesës",
  PermissionRecordUserRoleMapping: "Leja e rolit",
  Subscription: "Abonimi",
  PermissionRecord: "Leja",
  McpTool: "Mjeti MCP",
  MessageTemplate: "Shablloni i mesazhit",
  FlexiRideType: "Lloji FlexiRide",
  TravelConciergeType: "Lloji i konciergjit",
  EsimPartner: "Partneri eSIM",
  Affiliate: "Afiliati",
  CampaignVoucherCode: "Kodi i fushatës",
  BroadcastNotification: "Njoftimi masiv",
  FrequentlyAskedQuestion: "Pyetja e shpeshtë",
  FAQAnswer: "Përgjigjja e pyetjes",
  TrendingLocation: "Destinacioni në trend",
  PaymentSettings: "Cilësimet e pagesës",
  ServiceFeeConfiguration: "Tarifa e shërbimit",
  Language: "Gjuha",
  Composition: "Kompozicioni i ulëseve",
  InvitedUser: "Përdoruesi i ftuar",
  BlockedUser: "Përdoruesi i bllokuar",
  Wallet: "Portofoli",
  CustomTripWorkingDayPattern: "Modeli i ditëve të veçanta",
  CustomTripWorkingDayPatternDate: "Data e modelit",
  EsimPackageTemplate: "Paketa eSIM",
  LocationZone: "Zona eSIM",
  LocationZoneCountryMapping: "Shteti i zonës eSIM",
  EsimReservation: "Rezervimi eSIM",
  UserAccount: "Përdoruesi",
  OperatorCommisionFee: "Komisioni i operatorit",
  OperatorEntityCommisionFee: "Komisioni i orarit",
  OperatorInvoice: "Fatura e operatorit",
  Refund: "Rimbursimi",
  RefundLine: "Rreshti i rimbursimit",
  TicketInvoiceOnlyCancellation: "Anulimi i biletës në faturën e operatorit",
  WalletCredit: "Lëvizja në Gjirafa Money",
  WalletCreditConsumption: "Përdorimi i Gjirafa Money",
  WalletTransaction: "Transaksioni i portofolit",
  CreditReservationMapping: "Bllokimi i Gjirafa Money për blerjen",
  EntityPageSection: "Seksioni i faqes",
  OperatorInvoiceAdjustment: "Korrigjimi i faturës së operatorit",
  PaymentAttempt: "Përpjekja për pagesë",
  PaymentDispute: "Kontestimi i pagesës",
  PaymentProcessorRefund: "Rimbursimi në kartelë",
  LocalizedProperty: "Përkthimi",
  GTFSBlockedEntity: "Bllokimi GTFS",
  GTFSLine: "Linja GTFS",
  GTFSTrip: "Orari GTFS",
  GTFSStop: "Stacioni GTFS",
  GTFSShape: "Forma GTFS",
  GTFSAgency: "Agjencia GTFS",
  GTFSFeedInfo: "Të dhënat e feed-it GTFS",
  LinePage: "Faqja e linjës",
  LinePageSection: "Seksioni i faqes së linjës",
  CityPage: "Faqja e qytetit"
};
